import m from "../../es2015/themes/kelly";
window.am4themes_kelly = m;


//////////////////
// WEBPACK FOOTER
// ./themes/kelly.js
// module id = null
// module chunks = 